import { FC } from 'react'
import styles from './index.module.scss'
import { IJobBase } from '../../../types'
import { JobCardContainer } from '../JobCardContainer'
import { JobCardButtonGroup } from '../JobCardButtonGroup'

type Props = {
  job: IJobBase
  isRemovable?: boolean
}

export const JobCard: FC<Props> = ({ job, isRemovable = false }) => {
  return (
    <div className={styles.container}>
      <JobCardContainer job={job} />
      <JobCardButtonGroup job={job} isRemovable={isRemovable} />
    </div>
  )
}
